/*
 * @Author: lidan
 * @Date: 2020-11-09 09:49:29
 * @LastEditTime: 2021-01-08 16:48:09
 * @LastEditors: lidan
 * @Description: 片区管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\piece.js
 */

import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_BASE_WEB = "" } = e6ModuleBaseDataApi;

//********************* 片区管理 ****************** */

// 获取片区管理列表数据
export function findPagePiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/findPage`,
    method: "post",
    data
  });
}

// 片区管理新增
export function savePiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/save`,
    method: "post",
    data
  });
}

// 根据ID查询片区
export function getByIdPiece(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/findById`,
    method: "get",
    params
  });
}

// 片区管理修改
export function updatePiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/update`,
    method: "post",
    data
  });
}

// 片区管理删除
export function deletePiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/delete`,
    method: "post",
    data
  });
}

// 片区管理导出
export function exportPiece(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/export`,
    method: "post",
    data
  });
}

// 片区管理导入
export function importPiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/import`,
    method: "post",
    data
  });
}

// 片区名称唯一性校验
export function checkNamePiece(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/checkName`,
    method: "get",
    params
  });
}

// 片区代码唯一性校验
export function checkCodePiece(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/checkCode`,
    method: "get",
    params
  });
}

// 片区管理历史记录
export function historyPiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/findPieceAreaHistoryByPage`,
    method: "post",
    data
  });
}
